interface MetaTagsOptions {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const updateMetaTags = (options: MetaTagsOptions) => {
  const {
    title = 'Join Bilt Beta',
    description = 'Every build has a story. Document your modifications, media, events, awards, and milestones in one place on Bilt.',
    image = '/images/brand/hero-workshop-document.jpg',
    url = window.location.href,
    type = 'website'
  } = options;

  // Update document title
  document.title = title;

  // Helper function to update or create meta tags
  const updateMetaTag = (property: string, content: string, isProperty = false) => {
    const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
    let metaTag = document.querySelector(selector) as HTMLMetaElement;
    
    if (!metaTag) {
      metaTag = document.createElement('meta');
      if (isProperty) {
        metaTag.setAttribute('property', property);
      } else {
        metaTag.setAttribute('name', property);
      }
      document.head.appendChild(metaTag);
    }
    
    metaTag.setAttribute('content', content);
  };

  // Standard meta tags
  updateMetaTag('description', description);
  updateMetaTag('keywords', 'car enthusiast, vehicle modifications, build history, automotive community, Bilt');

  // Open Graph meta tags (Facebook, LinkedIn, etc.)
  updateMetaTag('og:title', title, true);
  updateMetaTag('og:description', description, true);
  updateMetaTag('og:image', image, true);
  updateMetaTag('og:url', url, true);
  updateMetaTag('og:type', type, true);
  updateMetaTag('og:site_name', 'Bilt', true);

  // Twitter Card meta tags
  updateMetaTag('twitter:card', 'summary_large_image');
  updateMetaTag('twitter:title', title);
  updateMetaTag('twitter:description', description);
  updateMetaTag('twitter:image', image);
  updateMetaTag('twitter:url', url);

  // Additional social sharing tags
  updateMetaTag('author', 'Bilt Team');
  updateMetaTag('robots', 'index, follow');
};

export const setInvitationMetaTags = (invitationCode?: string, codeDetails?: any) => {
  const baseTitle = 'Join Bilt Beta';
  const title = invitationCode 
    ? `${baseTitle} · ${invitationCode}`
    : baseTitle;
  
  const description = codeDetails?.description 
    ? `You’ve been invited to Bilt. ${codeDetails.description} Use code ${invitationCode} to start your garage.`
    : `You’ve been invited to Bilt. Every build has a story. Use your invitation code to start your garage.`;

  updateMetaTags({
    title,
    description,
    url: window.location.href
  });
};

export const resetDefaultMetaTags = () => {
  updateMetaTags({
    title: 'Bilt | Every build has a story.',
    description: 'Document your modifications, media, events, awards, and milestones in one place.',
    image: `${window.location.origin}/images/brand/hero-workshop-document.jpg`,
    url: window.location.origin,
  });
};
